<template>
  <div class="reports">
    <div class="row">
      <button
        id="print_round"
        @click="_toggleShowReportDatePicker"
        class="btn btn-plt"
      >
        Print Round Sheets
      </button>
      <button id="print_schedule" @click="_print_schedule" class="btn btn-plt">
        Print Schedule
      </button>
    </div>
    <ReportDatePicker
      ref="report_date_picker"
      v-show="showReportDatePicker"
      @print="_print_round"
      @close="_toggleShowReportDatePicker"
    />
  </div>
</template>

<script>
import ReportDatePicker from "@/components/report/ReportDatePicker.vue";
import { mapActions } from "vuex";

export default {
  name: "ReportPicker",
  data: () => ({
    showReportDatePicker: false,
  }),
  methods: {
    ...mapActions("report", ["getScheduleReport", "getWeekRoundSheetReport"]),
    _toggleShowReportDatePicker() {
      this.showReportDatePicker = !this.showReportDatePicker;
    },
    _print_round(dates) {
      this.getWeekRoundSheetReport(dates);
    },
    _print_schedule() {
      this.getScheduleReport();
    },
  },
  components: {
    ReportDatePicker,
  },
};
</script>
